import type { Theme, SxProps } from '@mui/material'
import { AppBar, Toolbar, LinearProgress, Stack, Divider } from '@mui/material'
import type { FC, ReactNode } from 'react'

export const getNavigationDrawerWidth = (isOpen: boolean): string =>
  isOpen ? '200px' : '55px'

type Props = {
  loading?: boolean
  content: ReactNode
  isNavigationDrawerOpen: boolean
}

const appBarHeight = 64

const progressBarHeight = 4

export const getBaseAppBarStyle = (isNavigationDrawerOpen: boolean): SxProps<Theme> => ({
  marginLeft: getNavigationDrawerWidth(isNavigationDrawerOpen),
  width: `calc(100% - ${getNavigationDrawerWidth(isNavigationDrawerOpen)})`,
  backgroundColor: theme => theme.palette.common.white,
})

export const headerAppBarHeight = appBarHeight + progressBarHeight

const HeaderAppBar: FC<Props> = ({ loading, content, isNavigationDrawerOpen }) => (
  <>
    <AppBar
      sx={{
        ...getBaseAppBarStyle(isNavigationDrawerOpen),
        height: appBarHeight,
      }}
    >
      <Toolbar>{content}</Toolbar>
      {loading ? (
        <span data-testid="page-loading">
          <LinearProgress sx={{ height: progressBarHeight }} />
        </span>
      ) : (
        <Stack
          minHeight={progressBarHeight}
          sx={theme => ({
            backgroundColor: theme.palette.common.white,
          })}
          justifyContent="end"
        >
          <Divider />
        </Stack>
      )}
    </AppBar>
    <Toolbar />
  </>
)

export default HeaderAppBar
